import * as React from 'react';
import Dialog from '@mui/material/Dialog';
import {DialogContent, IconButton,} from "@mui/material";
import {Close} from "@mui/icons-material";
import {ICalibration} from "../../types/models/Calibration.ts";
import Calibration from "../../pages/CalibrationPage/Calibration.tsx";
import DialogTitle from "@mui/material/DialogTitle";

export interface CalibrationDialogProps {
    open: boolean;
    handleClose: () => void;
    calibration: ICalibration;
}

export function CalibrationDialog(props: Readonly<CalibrationDialogProps>) {
    const {handleClose, open, calibration} = props;

    if (!calibration){
        return <></>;
    }

    return (<Dialog
            onClose={handleClose}
            open={open}
            fullWidth={true}
            maxWidth={"lg"}
            scroll={"paper"}
            sx={{my: 2}}
        >
            <DialogTitle sx={{m: 0, p: 2}} id={calibration._id}>
                Calibration
            </DialogTitle>
            <IconButton
                aria-label="close"
                onClick={handleClose}
                sx={(theme) => ({
                    position: 'absolute',
                    right: 12,
                    top: 12,
                    color: theme.palette.grey[500],
                })}>
                <Close/>
            </IconButton>
            <DialogContent dividers>
                <Calibration calibrationId={calibration._id}/>
            </DialogContent>
        </Dialog>
        );
}
